// src/components/ConfirmacionVenta.jsx
import React from 'react';
import { useUser } from '../context/UserContext';
import '../App.css';

function ConfirmacionVenta({ carrito, total, metodoPago, moneda, tasaBCV, onConfirm, onCancel }) {
  const { nombre } = useUser();
  const mostrarTasa = moneda === 'BS' && tasaBCV > 0;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Confirmar Venta</h3>
          <p className="usuario-logueado">Usuario actual: <strong>{nombre || 'Desconocido'}</strong></p>
        </div>
        <ul className="modal-list">
          {carrito.map((item, idx) => (
            <li key={idx}>
              {item.nombre} x{item.cantidad} - ${(item.precio * item.cantidad).toFixed(2)}
            </li>
          ))}
        </ul>
        <p><strong>Total:</strong> ${total.toFixed(2)}</p>
        {mostrarTasa && <p><strong>Total en Bs:</strong> {(total * tasaBCV).toFixed(2)} Bs (Tasa BCV: {tasaBCV})</p>}
        <p><strong>Método de pago:</strong> {metodoPago}</p>
        <p><strong>Moneda:</strong> {moneda}</p>
        <div className="modal-buttons">
          <button onClick={onConfirm} className="btn-registrar">Confirmar</button>
          <button onClick={onCancel} className="btn-imprimir">Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmacionVenta;
